export const mapProductToFormData = (product: App.Product, filesObj: App.ProductFilesObj) => {
  const formData = new FormData()

  for (const [fieldName, value] of Object.entries(filesObj)) {
    if (!value || !value?.name) continue

    formData.append(fieldName, value)
  }

  formData?.append("name", product.name)
  formData?.append("prefixUrl", product.prefixUrl)
  formData?.append("isFederated", product.isFederated.toString())
  formData?.append("isExternal", product.isExternal.toString())
  formData?.append("federatedKey", product.federatedKey)
  formData?.append("federationFields", JSON.stringify(product.federationFields))
  formData?.append("productInfo", JSON.stringify(product.productInfo))
  formData?.append("marketplaceInfo", JSON.stringify(product.marketplaceInfo))

  return formData
}
